let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kU2BU")).then(() => parcelRequire('ea71B'));